const CONSTANTS = {
	// Status
	CREATED: -1,
	WAITING: 0,
	PROCESSING: 1,
	DONE: 2,
	ERROR: 3,
	CANCELED: 4,
	VALIDATING: 5,
	SKIPPED: 6,
	RESETED: 7,
	STOPPED: 8,

	// Billing status
	BILLING: {0: 'A facturer', 1: 'Facturé', 2: 'Non facturé'},

	// Triggers
	AUTO: 0,
	MANUAL: 1,
	REQUEST: 2,
	PYTHON: 3,

	// Priorities
	LOW: 0,
	MEDIUM: 1,
	HIGHT: 2,

	// Typing
	PRODUCTION: 0,
	MIXIN: 1,
	BEHIVE: 2,
	MAM: 3,
	OUTIL: 4,
	SUIFA: 5,
	AUDIOTOOLS: 6,
	INGEST: 7,
	PACKLIV: 8,
	PRESTATION: 12,

	FOLDER: 16822,
	FILE: 33206,

	'Créé': -1,
	'En attente': 0,
	'En traitement': 1,
	'En validation': 5,
	'Terminé': 2,
	'Stoppé': 8,
	'En erreur': 3,
	'Annulé': 4,
	'Évité': 6,
	'Réinitialisé': 7,
	'Auto': 0,
	'Manuel': 1,
	'Demande': 2,
	'Python': 3,
	'Normale': 0,
	'Élevée': 1,
	'Haute': 2,
	'Production': 0,
	'Mixin': 1,
	'Editeur': 2,
	TICKETS_STATUS: [
		{ text: 'Open', label: 'Ouvert', value: 0 },
		{ text: 'Closed', label: 'Fermé', value: 1 },
		{ text: 'BackLog', label: 'Backlog', value: 2 }
	],
	TICKETS_COMMENT_EVENT: [
		{ text: 'Opening', label: 'Ouverture', value: 0 },
		{ text: 'Closure', label: 'Fermeture', value: 1 },
		{ text: 'Public comment', label: 'Public', value: 2 },
		{ text: 'Private comment', label: 'Privé', value: 3 },
		{ text: 'Assigned', label: 'Assignement', value: 4 }
	],
	TICKET_IMAGES_EXTS: [ '.jpg', '.jpeg', '.gif', '.png', '.bmp' ],
	TICKET_DOCUMENTS_EXTS: [ '.xls', '.xlsx' ],
	TICKET_ATTACHMENT_MAXSIZE: { text: '4Mo', value: 4096 }
}

CONSTANTS.install = function (Vue, options) {
	Vue.prototype.$getConst = (key) => {
		return CONSTANTS[key]
	}
}

export default CONSTANTS



// WEBPACK FOOTER //
// ./src/plugins/const.js